


















































































































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import AMSBreadcrumb from '@/components/AMSBreadcrumb.vue';
import AMSformTable from '@/components/AMSformTable.vue';
import AMSTable from '@/components/AMSTable.vue';
import AMSDialog from '@/components/AMSDialog.vue';
import request from '@/utils/request';
import { AppStore } from '@/store/modules/app';
import AMSProduct from '@/components/AMSProductCategorySelector.vue';
import AMSBrandSelector from '@/components/AMSBrandSelector.vue';
import AMSSelectedProduct from '@/components/AMSSelectedProduct.vue';
import moment from 'moment';
import Utils from '@/utils/utils';
import { allStaff } from '@/api/staff';
import { getDiscount, editDiscount, discountStatus } from '@/api/customer';
import { getProductCount } from '@/api/product';
import { getModuleName } from '@/utils/utils';
interface Form {
  filter?: string;
  categoryId?: string | null;
  productFilter?: string;
  saleId?: string | null;
  status?: Array<string>;
}
@Component({
  components: {
    'ams-formtable': AMSformTable,
    'ams-product': AMSProduct,
    'ams-breadcrumb': AMSBreadcrumb,
    'ams-dialog': AMSDialog,
    'ams-brand-selector': AMSBrandSelector,
    'ams-table': AMSTable
  }
})
export default class ProductStock extends Vue {
  form: Form = { saleId: null };
  selectedstatus: Array<any> = ['WaitConfirm'];

  onSaleIdClear() {
    setTimeout(() => {
      this.form.saleId = null;
    }, 1);
  }

  @Watch('selectedstatus')
  onSelect(newValue: string[]) {
    this.form.status = newValue;
  }
  confirmtype: string | undefined = '';
  BreadItem = [
    {
      text: '客户管理',
      disabled: false,
      href: 'customerDiscount'
    },
    {
      text: '客户折扣',
      disabled: true
    }
  ];
  confirmDialog: boolean = false;
  confirmLoading: boolean = false;
  discountId: string = '';
  discountItem: any = {};
  updateStatus: string = '';
  api: string = '/api/Customer/Discount/List';
  selected: Array<any> = [];
  selectAll: boolean = true;
  dialogTitle: string = '';
  staffList: Array<any> = [{ value: null, text: '全部' }];
  headers: object[] = [
    {
      isSelectAll: (props: any) => {
        return props.item.status == 'Pass' || props.item.status == 'NotPass' || props.item.status == 'Ban';
      },
      width: 60,
      align: 'left',
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '客户名',
      align: 'left',
      sortable: false,
      value: 'name',
      width: 120,
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) }, params.row['customer'] && params.row['customer'][params.keyName]);
      },
      bgColor:{ color:'#FFF3F3', field:'product.isHidden',type:'nest' }
    },
    {
      text: '手机号',
      align: 'left',
      value: 'phone',
      width: 120,
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) }, params.row['customer'] && params.row['customer'][params.keyName]);
      },
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '销售',
      align: 'left',
      value: 'sales',
      render: (h: any, params: any) => {
         let text = ''
         params.row.customer.sales.forEach((item: any)  => {
              text += `${item.staff.name}`
              text += '<br />'
            })
             return h('div', {
              domProps: {
                innerHTML: text
              },
              ...Utils.stausRenderDiableColor(params.row.status)
            })
      },
      width: 160,
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '商品分类',
      align: 'left',
      value: 'productCategory',
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) }, params.row[params.keyName] && params.row[params.keyName].name);
      },
      width: 150,
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '商品',
      align: 'left',
      value: 'product',
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) },
       `${params.row.product&&params.row.product.isHidden?'※ ':''}${params.row[params.keyName] && params.row[params.keyName].name||'--'}`  
         );
      },
      width: 150,
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '折扣值',
      align: 'right',
      render: (h: any, params: any) => {
        return h('div', { ...Utils.stausRenderDiableColor(params.row.status) }, this.computedDiscount(params.row));
      },
      width: 100,
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },

    {
      text: '创建时间',
      align: 'left',
      sortable: false,
      value: 'creationTime',
      isFormatDateTimeMM: true,
      width: 140,
      status: 'status',
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '状态',
      align: 'left',
      sortable: false,
      render: (h: any, params: any) => {
        return h(
          'span',
          {
            style: {
              color: this.switchStatus(params.row.status).color
            },
            class: {
              status: true
            },
            attrs: {
              'status-color': ''
            }
          },
          this.switchStatus(params.row.status).text
        );
      },
      width:90,
      bgColor:{ color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    },
    {
      text: '操作',
      value: 'actions',
      align: 'center',
      isDetail: [
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'detail');
          },
          text: '查看',
          color: '#1ABC9C'
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'edit');
          },
          text: '修改',
          color: '#1ABC9C',

          isShowBtn: (row: any) => {
            return (row.status == 'WaitConfirm' || row.status == 'NotPass') && Utils.isPermission('CustomerManager.CustomerDiscount.CreateOrEdit');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'Ban');
          },
          text: '停用',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status == 'Pass' && Utils.isPermission('CustomerManager.CustomerDiscount.Ban');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'Pass');
          },
          text: '审核通过',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status == 'WaitConfirm' && Utils.isPermission('CustomerManager.CustomerDiscount.UpdateStatus');
          }
        },
        {
          callBack: (btn: any, row: any, key: string) => {
            this.confirmItem(btn, row, key, 'NotPass');
          },
          text: '审核不通过',
          color: '#1ABC9C',
          isShowBtn: (row: any) => {
            return row.status == 'WaitConfirm' && Utils.isPermission('CustomerManager.CustomerDiscount.UpdateStatus');
          }
        }
      ],
      width:260,
      bgColor: { color:'#FFF3F3', field:'product.isHidden' ,type:'nest' }
    }
  ];
  created() {
    // this.initForm();
    this.getStaff();
    if (JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string)) {
      this.form = JSON.parse(localStorage.getItem(`${getModuleName(this.$route.name as string)}_search`) as string);
    }
    if (!this.form.status) {
      this.form.status = ['WaitConfirm'];
    } else {
      this.selectedstatus = this.form.status;
    }
  }
  getPermission(name: string) {
    return Utils.isPermission(name);
  }
  getStaff() {
    allStaff({ isActive: true, permissionCheck: true }).then((data: any) => {
      this.staffList = [{ value: null, text: '全部' }].concat(
        data.items.map((i: any) => {
          i.value = i.id;
          i.text = i.name;
          return i;
        })
      );
    });
  }

  switchStatus(status: string) {
    switch (status) {
      case 'WaitConfirm':
        return { color: '#FE5500', text: '待审核' };
      case 'Pass':
        return { color: '#00A854', text: '审核通过' };
      case 'NotPass':
        return { color: '#FF0000', text: '审核不通过' };
      case 'Ban':
        return { color: '#999999', text: '已停用' };
      default:
        return { color: '#454545', text: '' };
    }
  }

  computedDiscount(item: any) {
    if (item.discountRate !== null) {
      return item.discountRate + '%';
    }
    if (item.discountPrice !== null) {
      return this.formatPrice(item.discountPrice) + '元';
    }
  }

  processing(type?: string, val?: any) {
    this.confirmtype = type;
    this.updateStatus = val;
    this.confirmDialog = true;
    this.dialogTitle = this.computeTitle(type);
  }

  confirmItem(btn: any, row: any, key: string, type?: string, val?: any) {
    this.confirmtype = type;
    this.confirmDialog = true;
    this.discountId = row.item.id;
    this.dialogTitle = this.computeTitle(type);
    if (type == 'detail') {
      this.getCustomerDiscount();
    }
    if (type == 'edit') {
      this.discountItem = row.item;
      this.initDiscount();
    }
    if (type == 'process') {
      this.discountItem = row.item;
      this.updateStatus = val;
    }
    if (type == 'Pass' || type == 'NotPass') {
      this.discountItem = row.item;
      this.updateStatus = type;
    }
  }
  getCustomerDiscount() {
    getDiscount(this.discountId.toString()).then((data: any) => {
      this.discountItem = data;
    });
  }

  initDiscount() {
    //商品分类
    if (this.discountItem.productCategory !== null) {
      getProductCount({ categoryId: this.discountItem.productCategory.id }).then(data => {
        this.productCategorys.splice(0, 1, {
          id: this.discountItem.productCategory.id,
          productCategoryId: this.discountItem.productCategory.id,
          count: data,
          discountRate: this.discountItem.discountRate
        });
      });
      this.products = [{}];
    } else {
      this.products.splice(0, 1, {
        id: this.discountItem.product.id,
        productId: this.discountItem.product.id,
        orderPrice: this.discountItem.product.orderPrice,
        ...this.discountItem.product,
        discountPrice: this.discountItem.discountPrice
      });
      this.productCategorys = [{}];
    }
  }

  inputHandler(value: any, param: any) {
    if (!value) {
      this.productCategorys.splice(param.index, 1, Object.assign({}, param.row, { count: null, id: null, productCategoryId: null, discountRate: null }));
      return;
    }
    getProductCount({ categoryId: value }).then(data => {
      this.productCategorys.splice(param.index, 1, Object.assign({}, param.row, { count: data, id: value }));
    });
  }

  computeTitle(type?: string) {
    switch (type) {
      case 'detail':
        return '折扣详情';
      case 'edit':
        return '修改';
      default:
        return '请确认';
    }
  }
  confirmSure(stop: Function) {
    switch (this.confirmtype) {
      case 'Ban':
        let data = {
          status: 'Ban',
          discountIds: [this.discountId]
        };
        this.confirmLoading = true;
        this.upDownProduct(data);
        break;
      case 'Pass':
        this.confirmLoading = true;
        this.upDownProduct({
          status: this.updateStatus,
          discountIds: [this.discountId]
        });
        break;
      case 'NotPass':
        this.confirmLoading = true;
        this.upDownProduct({
          status: this.updateStatus,
          discountIds: [this.discountId]
        });
        break;
      case 'process':
        let arr: any = [];
        this.selected.forEach((ele: any) => {
          arr.push(ele.id);
        });
        this.confirmLoading = true;
        this.upDownProduct({
          status: this.updateStatus,
          discountIds: arr
        });
        break;
      case 'edit':
        let formData: any = {},
          isError: boolean = false;
        //商品分类
        if (this.discountItem.productCategory !== null) {
          formData = {
            productCategoryId: this.productCategorys[0].id,
            discountRate: this.productCategorys[0].discountRate,
            id: this.discountItem.id
          };

          if (!formData.productCategoryId) {
            AppStore.ShowError('请选择商品分类');
            isError = true;
          }
          if (!formData.discountRate) {
            AppStore.ShowError('折扣率不能为空！');
            isError = true;
          }
        } else {
          //商品
          formData = {
            productId: this.products[0].id,
            discountPrice: this.products[0].discountPrice,
            id: this.discountItem.id
          };
          if (!formData.productId) {
            AppStore.ShowError('请选择商品');
            isError = true;
          }
          if (!formData.discountPrice) {
            AppStore.ShowError('折扣价不能为空！');
            isError = true;
          }
        }
        if (isError) {
          stop()
          return
        };
        this.confirmLoading = true;
        editDiscount(formData)
          .then((data: any) => {
            this.confirmDialog = false;
            this.confirmLoading = false;
            this.discountItem = {};
            (this.$refs.formtable as HTMLFormElement).query();
          })
          .finally(() => {
            stop()
            this.confirmLoading = false;
          }).catch((err: any) => {
            stop()
            this.confirmLoading = false;
        });
        break;
      default:
        this.confirmDialog = false;
        break;
    }
  }
  upDownProduct(data: any) {
    const self = this;
    let formData = Object.assign({}, data);
    discountStatus(formData)
      .then((data: any) => {
        self.confirmDialog = false;
        self.discountId = '';
        AppStore.ShowSuccess('操作成功！');
        this.confirmLoading = false;
        (self.$refs.formtable as HTMLFormElement).query();
        (self.$refs.formtable as HTMLFormElement).clearSelected();
      })
      .catch(function(err: any) {
        self.confirmDialog = false;
        self.confirmLoading = false;
      })
      .finally(() => {
        self.confirmLoading = false;
        self.confirmLoading = false;
      });
  }
  confirmClose() {
    //有商品
    if (this.discountItem.product) {
      this.confirmDialog = false;
    }
    //无商品
    else {
      if (Object.keys(this.discountItem).length > 0) {
        this.productCategorys = [{}];
        this.$nextTick(() => {
          this.productCategorys.splice(0, 1, {
            id: this.discountItem.productCategory.id,
            productCategoryId: this.discountItem.productCategory.id,
            count: 0,
            discountRate: this.discountItem.discountRate
          });
          this.confirmDialog = false;
        });
      } else {
        this.confirmDialog = false;
      }
    }
  }
  getSelected(val: any) {
    this.selected = val;
  }
  initForm() {
    this.form = { categoryId: null, saleId: null, status: ['WaitConfirm'] };
    this.selectedstatus = ['WaitConfirm'];
  }
  newAccount(record: any, type: string) {
    this.$router.push({
      name: 'customerDiscount_create'
    });
  }

  categoryHeaders = [
    {
      text: '商品分类',
      value: 'productCategoryId',
      sortable: false,
      align: 'left',
      render: (h: Function, param: any) => {
        return h(AMSProduct, {
          props: {
            value: param.row[param.keyName],
            menuVisible: true
          },
          on: {
            input: (value: any) => {
              this.inputHandler(value, param);
            }
          }
        });
      }
    },
    {
      text: '关联商品数',
      value: 'count',
      align: 'right',
      sortable: false
    },
    { text: '折扣率', value: 'discountRate', align: 'right', sortable: false, isInputNumber: { type: 'isDiscountRate', symbol: '%' } }
  ];
  productHeaders = [
    {
      text: '商品',
      value: 'productId',
      align: 'left',
      sortable: false,
      render: (h: Function, param: any) => {
        return h(AMSSelectedProduct, {
          props: {
            items: param,
            selectedItems: this.products,
            isClearable: true,
            isHidden:param.row.isHidden
          },
          on: {
            autoComplete: (value: any) => {
              this.autoComplete(value, param);
            },
            clear: () => {
              this.clearProduct(param);
            }
          }
        });
      }
    },
    {
      text: '订货价',
      value: 'orderPrice',
      align: 'right',
      sortable: false
    },
    { text: '折扣价', value: 'discountPrice', align: 'right', sortable: false, isInputNumber: { type: 'isDiscountPrice', symbol: '元' } }
  ];

  productCategorys: Array<any> = [{}];
  products: Array<any> = [{}];

  categoryInput(value: any) {
    this.productCategorys = value;
  }
  productInput(value: any) {
    this.products = value;
  }

  autoComplete(value: any, param: any) {
    this.products.splice(param.index, 1, value);
  }
  clearProduct(param: any) {
    this.products.splice(0, 1, {
      id: null,
      productId: null,
      orderPrice: null,
      discountPrice: null
    });
  }
  formatDate(date: string) {
    return moment(date).format('YYYY-MM-DD');
  }
  formatPrice(num: number) {
    return Utils.formatCurrencyPrice(num);
  }

  renderList(param: any, label: string) {
    let staffs = param.row[label][param.keyName].map((k: any) => {
      return k.staff.name;
    });
    return staffs.join('、');
  }
}
